import React, { useState } from 'react';
import { useAlert } from 'react-alert'
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import PageHeader from "../../components/pageHeader/pageHeader.component";
import Mailbox from "../../assets/images/banners/mailbox.png";
import { sendMessage } from '../../actions/allActions'

import "./contactPage.module.css";

const initialState = {
    name: '',
    email: '',
    message: ''
}

const ContactPage = props => {

    const alert = useAlert()

    const [data, setData] = useState(initialState)

    const [error, setError] = useState('')

    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase())
    }

    const handleChange = e => {
        setData(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleSubmit = e => {
        e.preventDefault()
        setError('')

        if (data.message.length < 50 || data.message.length > 500) {
            setError('Message must be between 50 to 500 characters')
            return
        }

        if (!data.message || !data.name || !data.email) {
            alert.error("Please fill all the fields")
            return
        }

        const isValid = validateEmail(data.email)
        if (!isValid) {
            alert.error("Invalid email");
            return
        }

        sendMessage({ name: data.name, email: data.email, message: data.message, alert })
        setData(initialState)
    }

    return (
        <div>
            <PageHeader
                title="যোগাযোগ করুন"
                cover={Mailbox}
            >
                <p>
                    কঠিন বিষয়গুলো সহজে মনে রাখা জন্য Tricks শেখানো হয়। একইসাথে অধিক গুরুত্বপূর্ণ অংশগুলো চিহ্নিত করতে লাল
                    সবুজ কালিতে বই দাগানো হয়ে থাকে।
                </p>
            </PageHeader>
            <section className="py-5" styleName="contact-form-section">
                <Container>
                    <Row>
                        {/* <Col xs={12}>
                            <h3 className="text-center">Contact Us</h3>
                        </Col> */}
                        <Col xs={12}>
                            <Form styleName="contact-form" onSubmit={handleSubmit}>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="nameInput" className="pb-4">
                                        <Form.Label>Name</Form.Label>
                                        <Form.Control type="text" name="name" placeholder="Enter your name..." required={false} onChange={handleChange} value={data.name} />
                                    </Form.Group>

                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="emailInput" className="pb-4">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control type="email" name="email" placeholder="Enter your email..." required={false} onChange={handleChange} value={data.email} />
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="messageInput" className="pb-4">
                                        <Form.Label>Message</Form.Label>
                                        <Form.Control as="textarea" name="message" rows={4} placeholder="Write your message here..." required={false} onChange={handleChange} value={data.message} />
                                        <span>{data.message.length} character(s)</span>
                                        <br />
                                        <span className='d-inline-block mt-2 text-danger'>{error}</span>
                                    </Form.Group>
                                </Form.Row>
                                <Form.Row>
                                    <Col className="text-center">
                                        <Button variant="primary" type="submit" className="btn custom-btn-dark">
                                            Submit
                                        </Button>
                                    </Col>
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    )
}

export default ContactPage;